<template>
  <div class="lp-wave">
    <loanpro-logo v-if="aboveForm == 'default'" />
    <PismoAboveForm class="lp-float-logo" v-if="aboveForm == 'pismo'"></PismoAboveForm>
    <GalileoAboveForm class="lp-float-logo" v-if="aboveForm == 'galileo'"></GalileoAboveForm>
    <MasterCardAboveForm class="lp-float-logo" v-if="aboveForm == 'mastercard'"></MasterCardAboveForm>
    <ExperianAboveForm class="lp-float-logo" v-if="aboveForm == 'experian'"></ExperianAboveForm>
    <div class="lp-wave-bg">
      <div class="lp-wave-bg-scene"></div>
      <div class="lp-wave-bg-overlay"></div>
    </div>
    <router-view />
  </div>
</template>

<script setup lang="ts">
import LoanproLogo from '@/views/Common/components/LoanproLogo.vue'
import PismoAboveForm from '@/views/Login/components/PismoAboveForm.vue'
import GalileoAboveForm from '@/views/Login/components/GalileoAboveForm.vue'
import MasterCardAboveForm from '@/views/Login/components/MasterCardAboveForm.vue'
import ExperianAboveForm from './views/Login/components/ExperianAboveForm.vue'
import { onMounted, computed } from 'vue'
import { useConfigSync } from '@/config/useConfig'
const config = useConfigSync()

const aboveForm = computed(() => {
  return config?.looknfeel?.login_above_form || 'default'
})

onMounted(async () => {
  // Dynamically load lp-wave.js when the component is mounted
  import('@/assets/js/lp-wave.js')
    .then(() => {
      console.log('lp-wave.js loaded successfully.')
    })
    .catch((error) => {
      console.error('Failed to load lp-wave.js:', error)
    })
})
</script>

<style>
@import '@/assets/css/lp-wave.css';
/* LoanPro Wave CSS file */
#app {
  margin-top: 0 !important;
  width: 100%;
  text-align: left !important;
}

html,
body {
  height: 100%;
  padding: 0;
  margin: 0;
  background: #f2f4f7;
}

.btn-loading-active span.lp-btn-wrap-loading {
  padding-left: 0.5rem;
  margin-right: -0.5rem;
}

h1 {
  font-size: 32px !important;
  font-weight: 400 !important;
  color: var(--black-100) !important;
}

:root {
--primary: var(--indigo-100) !important;
--primary-hover: var(--indigo-140) !important;
--primary-active: var(--indigo-120) !important;
--primary-80: var(--indigo-80) !important;
--primary-60: var(--indigo-60) !important;
--primary-40: var(--indigo-40) !important;
--primary-30: var(--indigo-30) !important;
--primary-20: var(--indigo-20) !important;
--primary-10: var(--indigo-10) !important;

--button-background: var(--white) !important;
--button-border: var(--black-20) !important;
--button-text: var(--black-100) !important;
--button-background-hover: var(--white) !important;
--button-border-hover: var(--black-40) !important;
--button-text-hover: var(--black-100) !important;
--button-background-active: var(--white) !important;
--button-border-active: var(--black-40) !important;
--button-text-active: var(--black-100) !important;
--button-background-disabled: var(--white) !important;
--button-border-disabled: var(--black-20) !important;
--button-text-disabled: var(--black-30) !important;

--button-primary-background: var(--black-100) !important;
--button-primary-border: var(--black-100) !important;
--button-primary-text: var(--white) !important;
--button-primary-background-hover: var(--primary-hover) !important;
--button-primary-border-hover: var(--primary-hover) !important;
--button-primary-text-hover: var(--white) !important;
--button-primary-background-active: var(--primary-active) !important;
--button-primary-border-active: var(--primary-active) !important;
--button-primary-text-active: var(--white) !important;
--button-primary-background-disabled: var(--black-30) !important;
--button-primary-border-disabled: var(--black-30) !important;
--button-primary-text-disabled: var(--white) !important;

--button-secondary-background: var(--white) !important;
--button-secondary-border: var(--black-20) !important;
--button-secondary-text: var(--black-100) !important;
--button-secondary-background-hover: var(--white) !important;
--button-secondary-border-hover: var(--black-40) !important;
--button-secondary-text-hover: var(--black-100) !important;
--button-secondary-background-active: var(--white) !important;
--button-secondary-border-active: var(--black-40) !important;
--button-secondary-text-active: var(--black-100) !important;
--button-secondary-background-disabled: var(--white) !important;
--button-secondary-border-disabled: var(--black-20) !important;
--button-secondary-text-disabled: var(--black-30) !important;

--radio-color: var(--black-100) !important;
--checkbox-color: var(--black-100) !important;
--switch-color: var(--black-100) !important;
--switch-color-hover: var(--primary-active) !important;
}

.blue-button {
  color: #fff !important;
  background: #1a62ff !important;
  border-color: #1a62ff !important;
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}

.blue-button[disabled] {
  color: #fff !important;
  background: #8cb1ff !important;
  border-color: #8cb1ff !important;
  pointer-events: none !important;
}

.blue-button:hover {
  color: #fff !important;
  background: #0043d2 !important;
  border-color: #0043d2 !important;
}

.blue-outline-button {
  color: #1a62ff !important;
  background: #fff !important;
  border-color: #1a62ff !important;
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}

.blue-outline-button[disabled] {
  color: #8cb1ff !important;
  background: #fff !important;
  border-color: #8cb1ff !important;
  pointer-events: none !important;
}

.blue-outline-button:hover {
  color: #0043d2 !important;
  background: #fff !important;
  border-color: #0043d2 !important;
}

.lp input[type="password"] {
  height: 3rem;
}

.lp input[type="text"] {
  height: 3rem;
}

</style>
